import React from 'react'

import CloseIcon from '@mui/icons-material/Close'
import MenuIcon from '@mui/icons-material/Menu'
import { Box, IconButton, Menu } from '@mui/material'
import { Clipboard, Home, MessageSquare, Package, Plane, ShoppingBag, ShoppingCart, Tag } from 'lucide-react'

import router from '../../../../../router/functions/router.functions'
import useMenu from '../../../../hooks/menu.hooks'
import styles from './OverFlowMenu.styles'
import { OverFlowMenuProps } from './OverFlowMenu.types'

const routeIconMap: Record<string, React.ElementType> = {
  '/': Home,
  send: Package,
  shop: ShoppingBag,
  cart: ShoppingCart,
  offers: Tag,
  orders: ShoppingBag,
  'fulfillment-orders': Clipboard,
  'my-trips': Plane,
  requests: MessageSquare
}

const OverFlowMenu: React.FC<OverFlowMenuProps> = (props) => {
  const { pages } = props

  const navigate = router.navigate()
  const currentPage = router.getCurrentPage()
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null)
  const [getAdjustedMarginTop] = useMenu()

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget)
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null)
  }

  return (
    <Box sx={styles.menuContainer}>
      <IconButton
        size="large"
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleOpenNavMenu}
        color="inherit"
        sx={styles.menuIcon}
      >
        {anchorElNav === null ? <MenuIcon /> : <CloseIcon />}
      </IconButton>

      {/* TODO: Add sliding transition/animation to menu */}
      <Menu
        id="menu-appbar"
        anchorEl={anchorElNav}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        keepMounted
        open={Boolean(anchorElNav)}
        onClose={handleCloseNavMenu}
        sx={styles.menuContentContainer(getAdjustedMarginTop())}
      >
        {pages.map((page, index) => {
          const isActive = currentPage.path === page?.path
          const IconComponent = routeIconMap[page?.path] || Home

          return (
            <Box
              key={page?.name}
              onClick={() => {
                handleCloseNavMenu()
                navigate(page?.path)
              }}
              sx={styles.menuItem(isActive, index < pages.length - 1)}
            >
              <IconComponent size={18} color={isActive ? 'currentColor' : '#374151'} />
              {page?.name}
            </Box>
          )
        })}
      </Menu>
    </Box>
  )
}

export default OverFlowMenu
